<div
  class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm text-primary-500 dark:text-gray-100"
>
  <div
    class="-mt-4 -ml-4 flex flex-wrap items-center justify-between sm:flex-nowrap px-4 py-5 sm:px-6"
  >
    <div class="mt-4 ml-4 cursor-default">
      <h2 class="text-base font-header font-semibold">Considering a change?</h2>
    </div>
  </div>

  <div class="px-4 pb-2 sm:px-6 sm:pb-2 dark:bg-gray-900/20 text-gray-900 dark:text-gray-100">
    Learn more about listing your home with us and our complimentary relocation service.
  </div>

  <div class="px-4 pb-5 sm:px-6 sm:pb-6 grid grid-cols-2 gap-2">
    <button
      type="button"
      class="rounded-md px-2.5 py-1.5 text-sm font-semibold border border-primary-500 hover:bg-primary-500 hover:text-white w-full mt-6 cursor-pointer"
      (click)="postMessage('SELL')"
    >
      Sell
    </button>

    <button
      type="button"
      class="rounded-md px-2.5 py-1.5 text-sm font-semibold border border-primary-500 hover:bg-primary-500 hover:text-white w-full mt-6 cursor-pointer"
      (click)="postMessage('RELOCATE')"
    >
      Relocate
    </button>
  </div>
</div>
